import React, { useRef, useEffect } from 'react';
import './GridViewLayout.css';

// Helper component to bind a MediaStream to a video element
const RemoteVideo = ({ stream, className }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current && stream) {
            videoRef.current.srcObject = stream;
        }
    }, [stream]);

    return (
        <video
            ref={videoRef}
            autoPlay
            playsInline
            className={className}
        />
    );
};

const GridViewLayout = ({ participants = [], currentUser, micOn, camOn, selfVideoRef, selfVideoStyle, onMicToggle, onCamToggle, selfMicActive = false }) => {
    // Calculate grid dimensions based on participant count
    const count = participants.length + 1; // +1 for current user

    const getGridClass = (count) => {
        if (count <= 1) return 'grid-1';
        if (count <= 2) return 'grid-2';
        if (count <= 4) return 'grid-4';
        if (count <= 9) return 'grid-9';
        return 'grid-many';
    };

    return (
        <div className={`grid-view-layout ${getGridClass(count)}`}>
            {/* Current User */}
            <div className={`grid-tile self-tile ${selfMicActive && micOn ? 'speaking' : ''}`}>
                <div className="grid-video-placeholder">
                    {camOn && selfVideoRef ? (
                        <video
                            ref={selfVideoRef}
                            autoPlay
                            playsInline
                            muted
                            className="grid-self-video"
                            style={selfVideoStyle}
                        />
                    ) : (
                        <div className="grid-avatar">
                            {currentUser?.avatar || '👤'}
                        </div>
                    )}
                    <div className="grid-self-controls">
                        <button
                            className={`grid-control-btn ${micOn ? 'on' : 'off'}`}
                            onClick={onMicToggle}
                            title={micOn ? 'Mute' : 'Unmute'}
                        >
                            {micOn ? '🎤' : '🔇'}
                        </button>
                        <button
                            className={`grid-control-btn ${camOn ? 'on' : 'off'}`}
                            onClick={onCamToggle}
                            title={camOn ? 'Turn camera off' : 'Turn camera on'}
                        >
                            {camOn ? '📷' : '📷'}
                        </button>
                    </div>
                </div>
                <div className="grid-name-tag">
                    You {micOn ? '' : '🔇'}
                </div>
            </div>

            {/* Other Participants */}
            {participants.map(p => (
                <div key={p.id} className="grid-tile">
                    <div className="grid-video-placeholder">
                        {p.stream ? (
                            <RemoteVideo stream={p.stream} className="grid-remote-video" />
                        ) : (
                            <div className="grid-avatar">
                                {p.avatar || p.name?.[0] || '?'}
                            </div>
                        )}
                    </div>
                    <div className="grid-name-tag">
                        {p.name} {p.muted ? '🔇' : ''}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default GridViewLayout;
